<template>
  <div
    class="options_drop drop"
    :class="{ active: $store.state.mobile_exit_pop_up }"
    v-click-outside="hide"
  >
    <button @click="leave">Leave meeting</button>
    <button @click="$store.commit('showModal', 'end_meeting')">
      End meeting for all
    </button>
  </div>
</template>

<script>
import ClickOutside from "vue-click-outside";

export default {
  methods: {
    leave() {
      this.$store.dispatch("leave");
    },

    hide() {
      this.$store.commit("showMobileExitPopUp", false);
    },
  },

  mounted() {
    this.popupItem = this.$el;
  },

  directives: {
    ClickOutside,
  },
};
</script>

<style lang="scss" scoped>
.options_drop {
  z-index: 1;
  top: -142px;
  right: 0;
  width: 422px;

  @media all and (max-width: 767px) {
    width: 100%;
    top: -100px;
  }

  &::before {
    content: "";
    position: absolute;
    display: block;
    width: 150px;
    height: 50px;
    right: 0;
    top: 85%;
  }
}
</style>